import React, { PureComponent } from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import Input from './Input'
import {
  FORM_STYLES,
} from '../types'
import {
  FIELD_OPTIONS_SHAPE,
  FIELD_SET_SCHEMA_SHAPE,
  CUSTOM_INPUTS_SHAPE,
  SCHEMA_ITEM_SHAPE
} from '../shapes'

export default class FieldSet extends PureComponent {
  static displayName = 'Schemer.FieldSet'

  static propTypes = {
    className: T.string,
    readOnly: T.bool.isRequired,
    style: T.oneOf(Object.keys(FORM_STYLES)),

    fieldSetSchema: IT.mapContains(FIELD_SET_SCHEMA_SHAPE),
    fields: IT.mapOf(SCHEMA_ITEM_SHAPE),

    currentValues: IT.map,
    validate: T.func, // If passed, will be passed all group values after each input change. If a string is returned the group is considered invalid

    onChange: T.func.isRequired,
    onValidationChange: T.func.isRequired,
    customInputs: CUSTOM_INPUTS_SHAPE,
    fieldOptions: FIELD_OPTIONS_SHAPE
  }

  state = {
    groupInvalidMsg: null, //Map()
    allFieldsRequired: false
  }

  componentWillMount() {
    this._validateGroup(this.props)
  }


  componentWillReceiveProps(nextProps) {
    this._validateGroup(nextProps)
  }

  _validateGroup = props => {
    const {
      fieldSetSchema,
      currentValues,
      fields,
      onValidationChange
    } = props

    const {
      allRequired,
      validate,
      heading,
      id
    } = fieldSetSchema.toJS()

    // Subset of fields that contain non-falsy values
    const _currentValues = currentValues.filter(v => !!v)

    let newInvalidMsg = []

    // If any fieldSetSchema field has a value AND the group has allRequired: true,
    // then all other values become required
    const allFieldsRequired = allRequired && _currentValues.size > 0

    if (allFieldsRequired) {
      const hasMissingFields = !fields.every((field, fieldName) => {
        return _currentValues.has(fieldName)
      })
      if (hasMissingFields) {
        newInvalidMsg.push(`All ${ heading } fields must be completed.`)
      }
    }

    // Call passed FieldSet validator if supplied
    if (validate) {
      const groupInvalidMsg = validate(_currentValues)
      if (groupInvalidMsg) {
        newInvalidMsg.push(groupInvalidMsg)
      }
    }

    newInvalidMsg = newInvalidMsg.join("\r\n")

    onValidationChange(newInvalidMsg, heading, id)

    this.setState({
      groupInvalidMsg: newInvalidMsg,
      allFieldsRequired: allFieldsRequired
    })
  }

  render() {
    const  {
      style,
      readOnly,
      fieldSetSchema,
      fields,
      currentValues,
      onChange,
      onValidationChange,
      customInputs,
      fieldOptions,
      schema
    } = this.props
    const {
      groupInvalidMsg,
      allFieldsRequired
    } = this.state
    const {
      layout,
      heading
    } = fieldSetSchema.toJS()

    return (
      <div className={`schemer_fieldset layout_${layout.toLowerCase()}`}>
        <header>
          <div className="heading">{heading}</div>
        </header>
        {groupInvalidMsg &&
          <div className="schemer_fieldset_validation_errors">
            {groupInvalidMsg}
          </div>
        }
        <section className="schemer_fieldset_fields">
          {fields.entrySeq().map(([fieldKey, field]) => {
            return (
              <Input
                key={fieldKey}
                fieldName={fieldKey}
                field={field}
                schema={schema}
                label={field.get('display')}
                onChange={onChange}
                onValidationChange={onValidationChange}
                readOnly={readOnly}
                style={style}
                currentValue={currentValues.get(fieldKey)}
                required={allFieldsRequired || field.get('required')}
                customInputs={customInputs}
                fieldOptions={fieldOptions}
              />
            )
          })}
        </section>
      </div>
    )
  }
}